import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PaginationDiv from "modules/pagination/PaginationDiv";
import {
  convertDateFormat,
  convertSecondsToMinSec,
} from "modules/utilities/utility";

function ExotelData({ exotel, setDownloadData }) {
  const [page, newPage] = useState(1);
  const [exotelData, setExotelData] = useState([]);
  const [pageCount, setPageCount] = useState(1);

  useEffect(() => {
    setDownloadData("data");
    async function calculate() {
      const numOfSubarrays = Math.max(Math.ceil((exotel?.length || 0) / 10), 0);

      const arrayOfArrays = exotel
        ? Array.from({ length: numOfSubarrays }, (_, i) => {
            const start = i * 10;
            const end = start + 10;
            return exotel?.slice(start, end);
          })
        : [];
      setPageCount(Math.min(Math.ceil((exotel?.length || 0) / 10), 100));
      setExotelData(arrayOfArrays[page - 1]);
    }
    calculate();
  }, [exotel, page]);

  return (
    <div>
      <div style={{ minHeight: "70vh" }}>
        {Array.isArray(exotel) &&
          (exotel.length ? (
            <div className="my-3 shadow rounded">
              <div
                style={{ background: "#F9FAFD" }}
                className="d-flex p-3 border rounded-top"
              >
                <span className="flex-1">Customer</span>
                <span className="flex-1">Customer Number</span>
                <span className="flex-1">Agent Name</span>
                <span className="flex-1">Tag</span>
                <span className="flex-1">Start Time</span>
                <span className="flex-1">Call Duration</span>
                <span className="flex-1">Call Recording</span>
              </div>
              {exotelData?.map((data, index) => {
                return (
                  <div
                    className={`d-flex p-3 border border-top-0 ${
                      !exotelData[index + 1] && `rounded-bottom`
                    }`}
                  >
                    <span className="flex-1 text-primary">
                      <Link
                        to={`/lead-details/${data.case_id}`}
                        className="text-primary fw-bold text-capitalize"
                      >
                        {data.customer}
                      </Link>
                    </span>
                    <span className="flex-1">{data.customer_number}</span>
                    <span className="flex-1">{data.agent_name}</span>
                    <span className="flex-1">{data.tag}</span>
                    <span className="flex-1">
                      {convertDateFormat(data.start_time)}
                    </span>
                    <span className="flex-1">
                      {convertSecondsToMinSec(data.call_duration)}
                    </span>
                    <span className="flex-1">{data.call_recording}</span>
                  </div>
                );
              })}
            </div>
          ) : (
            <div>
              <div
                style={{ background: "#F9FAFD" }}
                className="d-flex p-3 border rounded-top"
              >
                <span className="flex-1">Customer</span>
                <span className="flex-1">Customer Number</span>
                <span className="flex-1">Agent Name</span>
                <span className="flex-1">Tag</span>
                <span className="flex-1">Start Time</span>
                <span className="flex-1">Call Duration</span>
                <span className="flex-1">Call Recording</span>
              </div>
              <div className="w-100 border p-3 rounded-bottom border-top-0 fw-bold text-black text-center">
                No Data available, apply filter to to get data
              </div>
            </div>
          ))}
      </div>
      {exotel && exotel.length && exotel.length > 10 ? (
        <div className="mt-3">
          <PaginationDiv
            newPage={newPage}
            paginationData={{ pageCount: pageCount || 1, page: page }}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export default ExotelData;
